var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.000501,
    height: 9.0002003,
    viewBox: "0 0 15.000501 9.0002003",
    fill: "none",
    id: "svg11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_8660)",
    id: "g4",
    transform: "rotate(-90,6.0000999,10.0001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15.5211,4.48825 c 0.3072,0.31537 0.4791,0.73823 0.4791,1.1785 0,0.44026 -0.1719,0.86312 -0.4791,1.1785 l -4.57,4.65495 4.57,4.655 c 0.3072,0.3154 0.4791,0.7383 0.4791,1.1785 0,0.4403 -0.1719,0.8632 -0.4791,1.1785 -0.1505,0.1546 -0.3304,0.2774 -0.5291,0.3612 -0.1987,0.0839 -0.4122,0.1271 -0.6279,0.1271 -0.2157,0 -0.4292,-0.0432 -0.6279,-0.1271 -0.1987,-0.0838 -0.3786,-0.2066 -0.5291,-0.3612 l -5.728,-5.833 C 7.17191,12.3639 7,11.941 7,11.5007 7,11.0605 7.17191,10.6376 7.4791,10.3222 l 5.728,-5.83395 C 13.3576,4.33373 13.5375,4.21092 13.7362,4.12706 13.9349,4.0432 14.1484,4 14.3641,4 c 0.2157,0 0.4292,0.0432 0.6279,0.12706 0.1987,0.08386 0.3786,0.20667 0.5291,0.36119 z",
    fill: "#385bf8",
    id: "path2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_8660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#ffffff",
    id: "rect6",
    x: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.cfba3fe5a3b43c159956da23ff3af652.svg";
export { ForwardRef as ReactComponent };